import { UserProfile } from 'mcsclient/models';
import { ApiCallResultStatus } from 'store/apiCallResultStatus';

export interface IUserProfileState {
  userProfile: UserProfile;
  userProfileLoadingStatus: ApiCallResultStatus;
  userProfileLoadError: string | undefined;
}

export function getDefaultUserProfileState(): IUserProfileState {
  return {
    userProfile: {},
    userProfileLoadingStatus: ApiCallResultStatus.DEFAULT,
    userProfileLoadError: undefined,
  };
}
